import React, { useState } from "react";
import PropTypes from "prop-types";
import { CButton } from "@coreui/react";

import UpdateTask from "./update-task";
import { TASK_TEMPLATE_TYPES } from "./taskUtility";

const CreateTask = ({ visible, setVisible, fetchBoard, className }) => {
  const [taskTemplateType, setTaskTemplateType] = useState(TASK_TEMPLATE_TYPES.NORMAL);

  return (
    <>
      <CButton
        className={`rs_btn-primary ${className || ""}`}
        color="primary"
        onClick={() => setVisible(true)}
      >
        Add Task
      </CButton>

      <UpdateTask
        visible={visible}
        setVisible={setVisible}
        fetchBoard={fetchBoard}
        updateTaskId={null}
        mode="create"
        taskTemplateType={taskTemplateType}
        onTaskTemplateTypeChange={setTaskTemplateType}
      />
    </>
  );
};

CreateTask.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  fetchBoard: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default CreateTask;
